import React, { createContext, useContext } from "react";
export const MiniHeaderIndicatorContext = /*#__PURE__*/createContext({
  inMiniHeader: false
});
export const MiniHeaderIndicatorContextProvider = ({
  children
}) => /*#__PURE__*/React.createElement(MiniHeaderIndicatorContext.Provider, {
  value: {
    inMiniHeader: true
  },
  "data-qa": "mini-header-indicator-context-provider"
}, children);
MiniHeaderIndicatorContext.displayName = "MiniHeaderIndicatorContext";
export const useMiniHeaderIndicatorContext = () => useContext(MiniHeaderIndicatorContext);